import { ArrowForwardIos, Message, RocketLaunch } from "@mui/icons-material";
import React, { memo } from "react";

import { Handle } from "react-flow-renderer";

export default memo(({ data, isConnectable }) => {
  return (
    <div
      style={{
        backgroundColor: "#ffffff",
        padding: "16px",
        borderRadius: "12px",
        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
        border: '1px solid #e5e7eb',
        minWidth: '280px',
        maxWidth: '320px'
      }}
    >
      {/* Header com ícone e título */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        marginBottom: '8px'
      }}>
        <RocketLaunch
          sx={{
            width: "18px",
            height: "18px",
            color: "#10b981"
          }}
        />
        <div style={{ 
          color: "#111827", 
          fontSize: "14px",
          fontWeight: 600
        }}>
          Início
        </div>
      </div>

      {/* Descrição */}
      <div style={{ 
        color: "#6b7280", 
        fontSize: "12px",
        lineHeight: '1.5'
      }}>
        Ponto inicial do fluxo
      </div>

      <Handle
        type="source"
        position="right"
        id="a"
        style={{
          background: "#3b82f6",
          width: "12px",
          height: "12px",
          top: "50%",
          right: "-6px",
          cursor: 'pointer',
          border: '2px solid white'
        }}
        isConnectable={isConnectable}
      />
    </div>
  );
});
